import React from 'react';
import styled from '@emotion/styled';
import RoundButton from '../../components/RoundButton';

import * as breakpoint from '../../styles/breakpoints.module.scss';
import { GatsbyImage } from "gatsby-plugin-image"
import AnimatedSection from '../../components/AnimatedSection';

const InstructionSection = ({ title, desc, button, image, annotation, direction }) => {


  return (
    <AnimatedSection>
      <InstructionWrapper>
        <InstructionRow className={direction}>
          <TextCol>
            <TitleLabel>{title}</TitleLabel>
            <DescLabel>{desc}</DescLabel>
            {annotation && 
              <AnnotationLabel>{annotation}</AnnotationLabel>
            }
            {button &&
              <DetailsButton href={button.href} color="#4E4E50">{button.label}</DetailsButton>
            }
          </TextCol>
          <ImageCol>
            {image.map((item,index) => <ImageFrame key={`instruction_${index}`}><GatsbyImage image={item.image} alt={item.alt}/></ImageFrame>)}
          </ImageCol>
        </InstructionRow>
      </InstructionWrapper>
    </AnimatedSection>
  );
}
 
export default InstructionSection;

const InstructionWrapper = styled.div`
  background: #FCFCFF;
  box-shadow: 0px 2px 2px -2px rgba(0, 0, 0, 0.05), 0px 6px 6px -6px rgba(0, 0, 0, 0.03), 0px 16px 14px -14px rgba(0, 0, 0, 0.03);
  border-radius: 6px;
  max-width:1344px;
  margin:48px auto 0;
  padding: 96px 64px;

  @media only screen and (max-width: ${breakpoint.smMax}){
    padding:64px;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    padding:24px;
    margin-top:16px;
  }

`

const InstructionRow = styled.div`
  display:flex;
  max-width:928px;
  width:100%;
  align-items:center;
  justify-content: space-between;
  margin:0 auto;

  &.left{
    flex-direction:row-reverse;
  }
  @media only screen and (max-width: ${breakpoint.smMax}){
    flex-direction:column !important;
  }
`

const ImageCol = styled.div`
  width:calc(50% - 32px);
  @media only screen and (max-width: ${breakpoint.smMax}){
    width:100%;
    margin-top:32px;
  }
`

const TextCol = styled.div`
  width:calc(50% - 32px);
  @media only screen and (max-width: ${breakpoint.smMax}){
    width:100%;
  }
`

const DetailsButton = styled(RoundButton)`
  margin-top:32px;
  padding:10px 24px;
  font-size: 16px;
  line-height: 24px;
  height:auto;
  border-radius:24px;
  box-sizing:border-box;

  @media only screen and (max-width: ${breakpoint.smMax}){
    height:auto;
    padding:6px 16px;
    font-size: 14px;
    line-height: 20px;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    height:auto;
    padding:6px 16px;
    font-size: 14px;
    line-height: 20px;
    margin-top:16px;
  }
`

const ImageFrame = styled.div`
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  border-radius: 6px;
  position:relative;
  z-index: 1;
  margin-bottom:32px;
  overflow:hidden;
  

  &:last-of-type{
    margin-bottom:0;
  }
`

const TitleLabel = styled.div`
  font-weight: 900;
  font-size: 32px;
  line-height: 44px;
  margin-bottom:32px;
  letter-spacing: 0.03em;
  color: #2C2C2E;

  @media only screen and (max-width: ${breakpoint.smMax}){
    font-size: 24px;
    line-height: 32px;
  }
  @media only screen and (max-width: ${breakpoint.xsMax}){
    font-size: 18px;
    line-height: 28px;
    margin-bottom:16px;
  }
`

const DescLabel = styled.div`
  font-size: 16px;
  line-height: 28px;
  color: #444448;
  @media only screen and (max-width: ${breakpoint.smMax}){
    font-size: 14px;
    line-height: 24px;
  }
  @media only screen and (max-width: ${breakpoint.xsMax}){
    font-size: 12px;
    line-height: 20px;
  }
`

const AnnotationLabel = styled.div`
  margin-top:16px;
  font-size: 16px;
  line-height: 28px;
  color: #444448;

  @media only screen and (max-width: ${breakpoint.smMax}){
    font-size: 14px;
    line-height: 24px;
  }
  @media only screen and (max-width: ${breakpoint.xsMax}){
    font-size: 12px;
    line-height: 20px;
  }
`
